export default __webpack_public_path__ + "static/char-s-32-ko-5ae814fd9e096f5100f0c9c2a1b58e9e.png";